import { useMemo } from 'react';
import { useAccessToken } from '@robinpowered/dashboard-apps-common';
/**
 * Build an `EventComposerConfig` from the inputs the `EventComposer` and
 * `EventDetails` components require.
 *
 * Returns `undefined` until tenant id, access token, base API URL, current
 * org, and current user are all available. Consumers should render `null` (or
 * a skeleton) while this is undefined.
 */
export var useEventComposerConfig = function (args) {
    var tenantId = args.tenantId, currentUser = args.currentUser, currentOrg = args.currentOrg, sessionCookieName = args.sessionCookieName, urls = args.urls;
    var accessToken = useAccessToken(sessionCookieName).accessToken;
    return useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!tenantId ||
            !accessToken ||
            !urls.featureFlagUrl ||
            !urls.integrationsServiceUrl ||
            !urls.apiUrl ||
            !urls.baseApiUrl ||
            !urls.dashboardUrl ||
            !urls.imageServerUrl ||
            !currentOrg ||
            !currentUser) {
            return undefined;
        }
        return {
            environmentUrls: {
                featureFlagUrl: urls.featureFlagUrl,
                integrationsServiceUrl: urls.integrationsServiceUrl,
                apiUrl: urls.apiUrl,
                baseApiUrl: urls.baseApiUrl,
                dashboardUrl: urls.dashboardUrl,
                imageServerUrl: urls.imageServerUrl,
            },
            userContext: {
                currentOrg: {
                    id: currentOrg.id,
                    name: (_a = currentOrg.name) !== null && _a !== void 0 ? _a : null,
                    slug: (_b = currentOrg.slug) !== null && _b !== void 0 ? _b : null,
                    avatar: (_c = currentOrg.avatar) !== null && _c !== void 0 ? _c : null,
                    logo: (_d = currentOrg.logo) !== null && _d !== void 0 ? _d : null,
                    features: (_e = currentOrg.features) !== null && _e !== void 0 ? _e : null,
                },
                currentUser: {
                    id: currentUser.id,
                    name: (_f = currentUser.name) !== null && _f !== void 0 ? _f : null,
                    timeZone: (_g = currentUser.timeZone) !== null && _g !== void 0 ? _g : null,
                    avatar: (_h = currentUser.avatar) !== null && _h !== void 0 ? _h : null,
                    primaryEmail: currentUser.primaryEmail
                        ? { email: currentUser.primaryEmail.email }
                        : null,
                },
            },
            accessToken: accessToken,
            tenantId: tenantId,
        };
    }, [
        tenantId,
        accessToken,
        currentOrg,
        currentUser,
        urls.featureFlagUrl,
        urls.integrationsServiceUrl,
        urls.apiUrl,
        urls.baseApiUrl,
        urls.dashboardUrl,
        urls.imageServerUrl,
    ]);
};
